import "./intervalsMenuPaymentPeriod.css";

export default function IntervalsMenuPaymentPeriod({
  paymentPeriod,
  setPaymentPeriod,
}) {
  const intervalsMenu = [
    {
      image: "",
      name: "Monthly",
    },
    {
      image: "",
      name: "Annually",
    },
  ];

  return (<div className="paymentPeriodBlock">
    <div className="intervalsMenu paymentPeriodMenu">
      {intervalsMenu.map((item) => {
        return (
          <span
            onClick={(e) => setPaymentPeriod(item.name)}
            className={item.name === paymentPeriod ? "activeInterval" : ""}
            key={item.name}
          >
            {item.name}
          </span>
        );
      })}
    </div>
    <div className="paymentPeriodNote">Annually you have 33% off which is 3 months free 😍</div>
    </div>
  );
}
